<template>
    <div class="input-control">
        <span>{{value}}</span>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";

    export default {
        name: "TextNode",
        mixins: [InputControlBase],
        methods: {
            setInputValue(value) {
                this.value = value;
            },
            focus() {

            }
        }
    }
</script>
